import * as React from 'react';

export const BigPayedIcon = (id: number | string, props?: React.HTMLAttributes<SVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg {...props} height="37" viewBox="0 0 28 37" width="28" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id={`payed-grad-${id}`} x1="50.052%" x2="50.052%" y1="99.964%" y2="-.022%">
        <stop offset="0%" stopColor="#FF5050" />
        <stop offset="54.2%" stopColor="#FF7B0D" />
        <stop offset="100%" stopColor="#FF8400" />
      </linearGradient>
    </defs>
    <path
      d="M4.89 0c-.238 0-.43.19-.43.428v17.606a.43.43 0 0 1-.427.43H1.236a.427.427 0 0 0-.428.427v3.26c0 .24.19.43.427.43H4.03c.237 0 .428.19.428.43v2.28c0 .24-.19.43-.427.43H1.24a.428.428 0 0 0-.428.43v3.25c0 .24.19.43.426.43H4.03c.237 0 .428.19.428.43v5.316c0 .236.192.428.43.428h3.924a.43.43 0 0 0 .43-.427V30.26c0-.237.19-.43.427-.43h15.29c.23 0 .43-.192.43-.43v-3.254c0-.236-.2-.428-.43-.428H9.67a.43.43 0 0 1-.43-.43V23.01a.43.43 0 0 1 .43-.43h3.633c5.142 0 8.224-1.234 10.694-3.705 2.005-2.006 3.19-4.883 3.19-8.023 0-3.958-1.65-6.733-4.32-8.585C20.607.67 17.777 0 13.51 0H4.89zm4.353 18.085V4.545c0-.237.192-.428.428-.428h3.53c3.04 0 4.89.36 6.43 1.386 1.75 1.13 2.57 3.035 2.57 5.502 0 2.265-.61 3.91-2.05 5.352-1.594 1.645-3.755 2.156-7.662 2.156h-2.81a.428.428 0 0 1-.426-.428h-.01z"
      fill={`url(#payed-grad-${id})`}
      fillRule="nonzero"
    />
  </svg>
);
